import { api } from ".";

export interface Privilege {
    Id: number;
    ApplicationId: number;
    Name: string;
    Description: string;
    IsActive: boolean
}

export interface AppPrivilegeModel {
  ApplicationId: number;
  Name: string;
  Description: string;
}

const privilegesUrlV1 = "/v1/Privileges";
const applicationsUrlV1 = "/v1/Applications";
const rolePrivilegesUrlV1 = "/v1/RolePrivileges";

export const getPrivilegesByApplicationId = async (appId: number) => {
  const response = await api.get<Privilege[]>(`${applicationsUrlV1}/${appId}/privileges`);
  return response?.data;
};

export const getPrivilegesByRoleId = async (roleId: number) => {
  const response = await api.get<Privilege[]>(`${rolePrivilegesUrlV1}/${roleId}/privileges`);
  return response?.data;
}

export const addPrivilege = async (appPrivilegeModel: AppPrivilegeModel) => {
  const response = await api.post(privilegesUrlV1, appPrivilegeModel);
  return response?.data;
}

export const deletePrivilege = async (privilegeId: number) => {
  const response = await api.delete(`${privilegesUrlV1}/${privilegeId}`);
  return response?.status === 204;
}